import {
  DOCUMENT_ITEM_FETCHING,
  DOCUMENT_ITEM_FAILED,
  DOCUMENT_ITEM_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case DOCUMENT_ITEM_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case DOCUMENT_ITEM_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case DOCUMENT_ITEM_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}